import { useCallback } from "react";
import { useStore } from "store";
import {
  runVendorCounterPromises,
  runYandexVendorOnUtm,
  yandexMetrica,
  YmEventProps,
} from "./helpers";

type EventProps = {
  pa: YmEventProps["pa"];
  productQuantity?: YmEventProps["productQuantity"];
  product: Entity.Product | Entity.Product.Short;
};
export const useYandexVendor = () => {
  const { meta } = useStore();

  const pageview = useCallback(
    (product: Entity.Product | Entity.Product.Short) => {
      runVendorCounterPromises(product.counters, item =>
        runYandexVendorOnUtm(
          tid =>
            yandexMetrica.pageview({
              dt: meta.meta.h1,
              tid,
            }),
          item
        )
      );
    },
    [meta.meta.h1]
  );

  const cartChangeCount = useCallback(
    ({ pa, productQuantity, product }: EventProps) => {
      runVendorCounterPromises(product.counters, item =>
        runYandexVendorOnUtm(
          tid =>
            yandexMetrica.event.cartChangeCount({
              productQuantity,
              pa,
              tid,
              product,
            }),
          item,
          1000
        )
      );
    },
    []
  );

  const purchase = useCallback(
    ({
      item,
      itemsParams,
    }: {
      item: Entity.Cart.Item;
      itemsParams: Record<string, string | number>;
    }) => {
      runVendorCounterPromises(item.product.counters, item =>
        runYandexVendorOnUtm(
          tid =>
            yandexMetrica.event.purchase({
              tid,
              itemsParams,
            }),
          item,
          1000
        )
      );
    },
    []
  );

  return {
    pageview,
    cartChangeCount,
    purchase,
  };
};
